import BaseObject from '../../../base/base_object';
import Strings from '../../../utils/strings';
import ServiceFactory from '../../service_factory';


class BaseIntegration extends BaseObject {
    static CLASS = 'BaseIntegration';

    init(params) {
        super.init(params);
    }

    /**
     * Bake params with a proper form and default data.
     *
     * @param dataObj
     * @param property
     * @returns {{}}
     */
    bakeParams(dataObj, property) {
        if (!dataObj) {
            this.logger.error('Provider data obj is not valid!');
            return {};
        }

        if (!dataObj[property]) {
            this.logger.error('Provider data obj data ' + property + ' is invalid.');
            return {};
        }

        return dataObj[property] || {};
    }


    /**
     * Request async http request to the olympus (b2c, b2x etc..).
     *
     * @param options
     * @returns {Promise.<T>|*|Promise}
     */
    send(options) {
        let stringUtil = new Strings(options.url);
        let shouldReplaceOrigin = stringUtil.startsWith('http://') || stringUtil.startsWith('https://');

        if (!shouldReplaceOrigin) {
            options.url = window.location.href + options.url;
        }

        return ServiceFactory.create().http2Service().post(options.url, options.params)
            .then(() =>{
                this.logger.debug('Success response => ', options.role);
            })
            .catch(() => {
                this.logger.error('Failed response from => ', options.role);
            });
    }
}

export default BaseIntegration;